import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { RequireAuth, RequireAdmin } from "./components/RequireAuth";

import Header from "./components/Header";
import HeroCarousel from "./components/HeroCarousel";
import Ticker from "./components/Ticker";
import FeaturesGrid from "./components/FeaturesGrid";
import SpreadsTable from "./components/SpreadsTable";
import PoweredTools, { TrustBar } from "./components/PoweredTools";
import { StepsSection, Testimonials, MakeYourMoveBanner } from "./components/Sections";
import Footer from "./components/Footer";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Legal from "./pages/Legal";

import DashboardOverview from "./pages/DashboardOverview";
import DashboardTrade from "./pages/DashboardTrade";
import DashboardPositions from "./pages/DashboardPositions";
import DashboardHistory from "./pages/DashboardHistory";
import DashboardFunds from "./pages/DashboardFunds";
import DashboardReports from "./pages/DashboardReports";
import DashboardSettings from "./pages/DashboardSettings";
import CopyTrading from "./pages/CopyTrading";
import CopyTraderDetail from "./pages/CopyTraderDetail";
import Affiliate from "./pages/Affiliate";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminDeposits from "./pages/admin/AdminDeposits";
import AdminWithdrawals from "./pages/admin/AdminWithdrawals";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import AdminCopyTrading from "./pages/admin/AdminCopyTrading";
import AdminKYC from "./pages/admin/AdminKYC";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAffiliates from "./pages/admin/AdminAffiliates";
import RefCapture from "./components/RefCapture";
import ChatVisibility from "./components/ChatVisibility";

const Home = () => {
  return (
    <div className="min-h-screen bb-bg text-white relative overflow-x-hidden">
      <div className="absolute inset-0 grid-pattern pointer-events-none opacity-30"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-gradient-to-br from-[#1c3df5]/15 to-transparent blur-3xl pointer-events-none"></div>
      <div className="relative z-10">
        <Header />
        <HeroCarousel />
        <Ticker />
        <FeaturesGrid />
        <SpreadsTable />
        <PoweredTools />
        <MakeYourMoveBanner />
        <TrustBar />
        <StepsSection />
        <Testimonials />
        <Footer />
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <RefCapture />
            <ChatVisibility />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/terms" element={<Legal doc="terms" />} />
              <Route path="/privacy" element={<Legal doc="privacy" />} />
              <Route path="/risk-disclosure" element={<Legal doc="risk" />} />

              <Route path="/dashboard" element={<RequireAuth><DashboardOverview /></RequireAuth>} />
              <Route path="/dashboard/trade" element={<RequireAuth><DashboardTrade /></RequireAuth>} />
              <Route path="/dashboard/copy-trading" element={<RequireAuth><CopyTrading /></RequireAuth>} />
              <Route path="/dashboard/copy-trading/:traderId" element={<RequireAuth><CopyTraderDetail /></RequireAuth>} />
              <Route path="/dashboard/affiliate" element={<RequireAuth><Affiliate /></RequireAuth>} />
              <Route path="/dashboard/positions" element={<RequireAuth><DashboardPositions /></RequireAuth>} />
              <Route path="/dashboard/history" element={<RequireAuth><DashboardHistory /></RequireAuth>} />
              <Route path="/dashboard/deposits" element={<RequireAuth><DashboardFunds /></RequireAuth>} />
              <Route path="/dashboard/reports" element={<RequireAuth><DashboardReports /></RequireAuth>} />
              <Route path="/dashboard/settings" element={<RequireAuth><DashboardSettings /></RequireAuth>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
              <Route path="/admin/deposits" element={<RequireAdmin><AdminDeposits /></RequireAdmin>} />
              <Route path="/admin/withdrawals" element={<RequireAdmin><AdminWithdrawals /></RequireAdmin>} />
              <Route path="/admin/users" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />
              <Route path="/admin/users/:userId" element={<RequireAdmin><AdminUserDetail /></RequireAdmin>} />
              <Route path="/admin/copy-trading" element={<RequireAdmin><AdminCopyTrading /></RequireAdmin>} />
              <Route path="/admin/kyc" element={<RequireAdmin><AdminKYC /></RequireAdmin>} />
              <Route path="/admin/affiliates" element={<RequireAdmin><AdminAffiliates /></RequireAdmin>} />
              <Route path="/admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
